import {
    ApplicationState,
    CommanderThunkDispatch,
    WithAvailabilityBlockId,
    WithServiceId,
} from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { fetchActiveEnterpriseServices } from '@mews-commander/legacy-entities/src/actions/services';
import { fetchAvailabilityBlocks } from '@mews-commander/legacy-entities/src/actions/availabilityBlocks';
import { fetchRates } from '@mews-commander/legacy-entities/src/ducks/rates';
import { isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { getEnterpriseIdFromServiceId } from '@mews-commander/legacy-entities/src/ducks/services';
import { getAvailabilityBlock } from '@mews-commander/legacy-entities/src/ducks/availabilityBlocks';
import { AVAILABILITY_BLOCK_ENTITY_FORM_INIT } from './actionTypes';

export const checkAvailabilityBlockEditPrivilege = (
    state: ApplicationState,
    { serviceId, availabilityBlockId }: WithServiceId & WithAvailabilityBlockId
) => {
    const enterpriseId = getEnterpriseIdFromServiceId(state, { serviceId });
    const currentEnterpriseId = getCurrentEnterpriseId();

    const availabilityBlock = getAvailabilityBlock(state, { id: availabilityBlockId });

    return availabilityBlock !== undefined && enterpriseId === currentEnterpriseId;
};

export const checkAvailabilityBlockCreatePrivilege = (state: ApplicationState, { serviceId }: WithServiceId) => {
    const enterpriseId = getEnterpriseIdFromServiceId(state, { serviceId });
    const currentEnterpriseId = getCurrentEnterpriseId();

    return enterpriseId === currentEnterpriseId && isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled(state);
};

interface fetchAvailabilityBlockDependenciesParams {
    availabilityBlockId?: string;
    dispatch: CommanderThunkDispatch;
    serviceId: string;
}

export const fetchAvailabilityBlockDependencies = async ({
    availabilityBlockId,
    dispatch,
    serviceId,
}: fetchAvailabilityBlockDependenciesParams) => {
    const enterpriseId = getCurrentEnterpriseId();

    await Promise.all([
        dispatch(
            fetchActiveEnterpriseServices({
                enterpriseIds: [enterpriseId],
                serviceIds: [serviceId],
            })
        ),
        availabilityBlockId !== undefined
            ? dispatch(
                  fetchAvailabilityBlocks({
                      enterpriseIds: [enterpriseId],
                      availabilityBlockIds: [availabilityBlockId],
                      serviceIds: [serviceId],
                      extent: {
                          profiles: true,
                          adjustments: false,
                          serviceOrders: false,
                      },
                  })
              )
            : Promise.resolve(),
    ]);

    const form =
        availabilityBlockId !== undefined
            ? `availability-block-edit-${availabilityBlockId}`
            : `availability-block-create-${serviceId}`;

    dispatch(createAction(AVAILABILITY_BLOCK_ENTITY_FORM_INIT, undefined, { scope: form }));
};
export const fetchAvailabilityBlockDependenciesLegacy = async (
    // @ts-expect-error removed universal router RouteLeaf['fetchDependency']
    context,
    { availabilityBlockId }: { availabilityBlockId?: string }
) => {
    const {
        dispatch,
        search: { OwnerId: serviceId },
    } = context;
    const enterpriseId = getCurrentEnterpriseId();

    await Promise.all([
        dispatch(
            fetchActiveEnterpriseServices({
                enterpriseIds: [enterpriseId],
                serviceIds: [serviceId],
            })
        ),
        dispatch(fetchRates({ serviceIds: [serviceId] })),
        availabilityBlockId !== undefined
            ? dispatch(
                  fetchAvailabilityBlocks({
                      enterpriseIds: [enterpriseId],
                      availabilityBlockIds: [availabilityBlockId],
                      serviceIds: [serviceId],
                      extent: {
                          profiles: true,
                          adjustments: false,
                          serviceOrders: false,
                      },
                  })
              )
            : Promise.resolve(),
    ]);

    const form =
        availabilityBlockId !== undefined
            ? `availability-block-edit-${availabilityBlockId}`
            : `availability-block-create-${serviceId}`;

    dispatch(createAction(AVAILABILITY_BLOCK_ENTITY_FORM_INIT, undefined, { scope: form }));
};
